import type { ModalClassNames } from './ModalProvider';

/**
 * Places a stacked modal as the new design's side sheet: against the window's end, at the top and the gap its side
 * panels keep. Every class is `new:`, so classic still centres the modal; `!` outweighs a caller's inline width.
 */
const SIDE_SHEET =
    'new:top-(--panel-top) new:right-(--panel-gap) new:bottom-(--panel-gap) new:left-auto new:max-h-none new:max-w-[calc(100vw-2*var(--panel-gap))] new:translate-x-0 new:translate-y-0 new:rounded-2xl new:sm:max-w-[calc(100vw-2*var(--panel-gap))]';

/** A sheet leaves the page readable behind it: the soft scrim confirmations use, not a dialog's darker one. */
const SHEET_SCRIM = 'new:bg-scrim-soft';

/** The send e-mail sheet and its check-before-sending step. */
export const SEND_SHEET: ModalClassNames = { panel: `${SIDE_SHEET} new:w-[720px]!`, overlay: SHEET_SCRIM };

/** Customise invoice and spec, beside the invoice it customises. */
export const CUSTOMISE_SHEET: ModalClassNames = { panel: `${SIDE_SHEET} new:w-[840px]!`, overlay: SHEET_SCRIM };

/** A field's history, beside the record whose field it is. */
export const HISTORY_SHEET: ModalClassNames = { panel: `${SIDE_SHEET} new:w-[440px]!`, overlay: SHEET_SCRIM };
